// probably timing problem with lit: https://github.com/lit/lit/blob/7453e365000e6a289c139cf7e175a4742296333d/packages/reactive-element/src/css-tag.ts#L10
// if lit is loaded before style sheet it cannot handle CSSStyleSheets from AdornisCSS
import 'construct-style-sheets-polyfill'; // THIS HAS TO BE THE FIRST IMPORT FOR FIREFOX TO WORK CORRECTLY

import { BaseQLClient } from '@adornis/baseql/client/baseqlClient.js';
import { selectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { registerMatchingMails } from '@adornis/bh-matching-mails/mail-registry.js';
import '@adornis/bh-matching-mails/templates/index.js';
import '@adornis/bh-matching-translation/translations.js';
import { User } from '@adornis/buchungsheld-db/entities/user.js';
import '@adornis/buchungsheld-theme/index.js';
import '@adornis/fonts/fonts.js';
import '@adornis/fonts/fontSrc/lato.js';
import '@adornis/fonts/fontSrc/maven-pro.js';
import { initApp } from '@adornis/functional-lit/init-app.js';
import { subscribeTranslationDictionaryAndUpdateClientTranslator } from '@adornis/translation/db/translation-entry.js';
import { subscribeCurrentUser } from '@adornis/users/client/currentUser.js';
import { html } from 'lit';
import '../api/index.js';
import '../translations.js';
import './main-element.js';

BaseQLClient.initDefault();

void subscribeCurrentUser(() => selectionSet(() => User, 3, ['participations']));

subscribeTranslationDictionaryAndUpdateClientTranslator().subscribe();

registerMatchingMails();

initApp(() => html` <main-element></main-element> `);
